import { Data } from 'signup-constants/signupData/Data';
import { getFlowSteps } from '../flow-initial/getFlowConfig';
import { setNextSteps, replaceCurrentStep } from '../store/flow/action-creators';
import { Step } from 'signup-constants/Step';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { isOAuthSignup } from '../app/verificationTypeSelectors';
import { getCurrentStep } from '../store/flow/selectors';
import { getShouldAddHubletSelection } from '../flow-branches/branches/BranchAddHubletNewUser';
export const getGTKMDataNotEmptyCount = gtkmData => {
  return Object.values(Data).filter(dataKey => {
    const value = gtkmData[dataKey];
    return value && value.trim() !== '';
  }).length;
};
export const updateStepOrdersAfterAuth = ({
  gtkmData,
  dispatch,
  state,
  isFreeEmailDomain = false,
  isGTKMEndpointFailed = false
}) => {
  const {
    postAccountCreation
  } = getFlowSteps();
  const postVerificationStepsDefault = [...(!gtkmData[Data.Industry] ? [Step.Industry] : []), Step.ManagementLevel, ...(!gtkmData[Data.CompanySize] ? [Step.CompanySize] : []), ...(!gtkmData[Data.CompanyName] ? [Step.CompanyName] : []), Step.Review];
  const postVerificationStepsOnlyFoundDomain = [Step.ManagementLevel, Step.CompanyDomain, Step.LoadingPage];
  const shouldUsePostVerificationStepsOnlyFoundDomain = getGTKMDataNotEmptyCount(gtkmData) === 1 || isFreeEmailDomain || isGTKMEndpointFailed;
  const postVerificationSteps = shouldUsePostVerificationStepsOnlyFoundDomain ? postVerificationStepsOnlyFoundDomain : postVerificationStepsDefault;
  const firstName = getSignupDataValue(state, Data.FirstName);
  const lastName = getSignupDataValue(state, Data.LastName);
  const nextSteps = [...(isOAuthSignup(state) ? [] : [Step.Password]), ...(isOAuthSignup(state) && firstName && lastName ? [] : [Step.Name]), ...postVerificationSteps, ...postAccountCreation];
  const shouldAddHubletSelection = getShouldAddHubletSelection(state);
  if (shouldAddHubletSelection) {
    nextSteps.push(Step.HubletSelection);
  }
  dispatch(replaceCurrentStep(nextSteps[0]));
  dispatch(setNextSteps(nextSteps.slice(1)));
  return nextSteps;
};
export const updateStepOrdersInDomainStep = ({
  gtkmData,
  dispatch,
  domainHavenotChanged = false,
  isGTKMEndpointFailed = false,
  state
}) => {
  const gtkmDataNotEmptyCount = getGTKMDataNotEmptyCount(gtkmData);
  const noExtraDataFoundExceptDomain = gtkmDataNotEmptyCount === 1;
  const foundOneExtraDataExceptDomain = gtkmDataNotEmptyCount === 2;
  const foundTwoMoreExtraDataExceptDomain = gtkmDataNotEmptyCount >= 3;
  const NotEmptyDataKeys = [...(gtkmData[Data.Industry] ? [Step.Industry] : []), ...(gtkmData[Data.CompanySize] ? [Step.CompanySize] : []), ...(gtkmData[Data.CompanyName] ? [Step.CompanyName] : [])];
  const emptyDataKeys = [...(!gtkmData[Data.Industry] ? [Step.Industry] : []), ...(!gtkmData[Data.CompanySize] ? [Step.CompanySize] : []), ...(!gtkmData[Data.CompanyName] ? [Step.CompanyName] : [])];
  let nextSteps = [];
  if (noExtraDataFoundExceptDomain || domainHavenotChanged || isGTKMEndpointFailed) {
    nextSteps = [Step.Industry, Step.CompanySize, Step.CompanyName];
  } else if (foundOneExtraDataExceptDomain) {
    nextSteps = [...NotEmptyDataKeys, ...emptyDataKeys];
  } else if (foundTwoMoreExtraDataExceptDomain) {
    nextSteps = [Step.Review, ...emptyDataKeys];
  }
  const shouldAddHubletSelection = getShouldAddHubletSelection(state);
  if (shouldAddHubletSelection) {
    nextSteps.push(Step.HubletSelection);
  }
  dispatch(setNextSteps(nextSteps));
  return nextSteps;
};
export const updateStepOrdersAfterGTKMAPISuccess = ({
  gtkmData,
  dispatch,
  state,
  isFreeEmailDomain = false
}) => {
  const currentStep = getCurrentStep(state);
  const afterAuth = currentStep === Step.LoadingPage;
  const inDomainStep = currentStep === Step.CompanyDomain;
  if (afterAuth) {
    updateStepOrdersAfterAuth({
      gtkmData,
      dispatch,
      state,
      isFreeEmailDomain
    });
  } else if (inDomainStep) {
    updateStepOrdersInDomainStep({
      gtkmData,
      dispatch,
      state
    });
  }
};
export const updateStepOrdersAfterGTKMAPIFailure = ({
  gtkmData,
  dispatch,
  state
}) => {
  const currentStep = getCurrentStep(state);
  const afterAuth = currentStep === Step.LoadingPage;
  const inDomainStep = currentStep === Step.CompanyDomain;
  if (afterAuth) {
    updateStepOrdersAfterAuth({
      gtkmData,
      dispatch,
      state,
      isGTKMEndpointFailed: true
    });
  } else if (inDomainStep) {
    updateStepOrdersInDomainStep({
      gtkmData,
      dispatch,
      isGTKMEndpointFailed: true,
      state
    });
  }
};